import { useNavigate } from 'react-router-dom';
import { useGetSceneProducts } from '../../../domains/scene/ui/hooks/useGetSceneProducts';
import { useGetUserInfo } from '../../../domains/user/ui/hooks/useGetUserInfo';
import { openNewTab } from '../../../utils/UIUtils';
import AnimationStarBeam from './AnimationStarBeam';
import type { components } from '../../../types/schema';

type SceneProduct = components['schemas']['ApiV1SceneProduct'];

interface SceneOriginalProductListProps {
  sceneId: string;
  castRelationshipId: string;
  isFullAccessPurchased: boolean;
}

const SceneOriginalProductList = ({
  sceneId,
  castRelationshipId,
  isFullAccessPurchased
}: SceneOriginalProductListProps) => {
  const navigate = useNavigate();
  const { data: sceneProducts } = useGetSceneProducts({
    category: 'original_full',
    scene_id: sceneId,
    cast_relationship_id: castRelationshipId
  });
  const { data: user } = useGetUserInfo();

  const handleBuyProduct = (product: SceneProduct) => {
    if (isFullAccessPurchased) {
      navigate(`/scene/${sceneId}/original-episodes`);
      return;
    }
    const amount = Number(product?.amount);
    const baseParams = new URLSearchParams({
      amount: String(amount),
      productName: product?.name,
      productId: product?.sceneProductId,
      productType: 'scene_product',
      sceneId: sceneId
    });
    if (user?.identified) {
      openNewTab(`/payment/inicis?${baseParams.toString()}`);
    } else {
      openNewTab(`/identity-verification/intro?${baseParams.toString()}`);
    }
  };
  return (
    <div className="relative h-[543px] mt-[77px]">
      <div
        className="absolute inset-0 bg-[linear-gradient(180deg,#000_0%,rgba(0,0,0,0.00)_100%),linear-gradient(136deg,#15CCCB_1.21%,#4987FF_50.69%,#8B1CFA_101.7%)] opacity-50"
        aria-hidden
      />
      <div className="relative z-10">
        <AnimationStarBeam />
        <div className="flex flex-col items-center justify-center gap-[6px]">
          <p className="text-[18px] font-bold leading-[21px] text-pure-white">
            전체 프리뷰 열어보기
          </p>
          <p className="text-[13px] leading-[16px] text-pure-white">
            원문 구매 시 전체 프리뷰도 같이 제공돼요
          </p>
        </div>
        <div className="mt-[42px] px-[24px] flex flex-col items-center gap-[10px]">
          {sceneProducts?.map((product) => (
            <div
              key={product.sceneProductId}
              className="p-[18px] rounded-[16px] bg-white-opacity-50 w-full flex items-center justify-between"
            >
              <div className="flex items-center gap-[11px]">
                <div className="w-[46px] h-[73px] rounded-[5px] border border-pure-black bg-blue-300" />
                <div className="flex flex-col items-start gap-[6px]">
                  <p className="text-[17px] font-semibold leading-[20px] text-[#FFF]">
                    {product?.name}
                  </p>
                  <p className="text-[12px] font-medium leading-[14px] text-[rgba(255,255,255,0.80)]">
                    작가 · 글자수
                  </p>
                  <p className="text-[16px] font-semibold leading-[19px] text-[#FFF]">
                    {Number(product?.amount).toLocaleString()}원
                  </p>
                </div>
              </div>
              <button
                type="button"
                className="px-[12px] py-[8px] rounded-[32px] bg-[#FFF] text-[#444] font-semibold text-[14px] leading-[17px] border border-separator-light-1"
                onClick={() => handleBuyProduct(product)}
              >
                {isFullAccessPurchased ? '감상하기' : '구매하기'}
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SceneOriginalProductList;
